// 集成所有用户请求
import httpRequest from '@/utils/request'

const commonBasicURL = 'Common/api/v2'
const merchantBasicURL = 'merchant/api/v2'

/**
 * 登录操作
 * @param {Object} data 发送给BE的登录数据
 */
export function login (data) {
  return httpRequest.fetchPost(`${commonBasicURL}/login`, data)
}

/**
 * 登出操作
 */
export function logout () {
  return httpRequest.fetchPost(`${commonBasicURL}/Logout`)
}

export function getCodeIMG () {
  return httpRequest.registerRequest(`${commonBasicURL}/GetVerificationCodeImage`)
}

/**
 * 验证码发送请求
 * @param {Object} data 请求验证码的数据
 */
export function sendCode (data) {
  return httpRequest.registerRequest(`${commonBasicURL}/SendSmsVerificationCode`, data)
}

/**
 * 注册操作请求
 * @param {Object} data 注册数据
 */
export function register (data) {
  return httpRequest.registerRequest(`${merchantBasicURL}/Register`, data)
}



// WEBPACK FOOTER //
// ./src/api/user.js